import { SearchX, Home } from 'lucide-react';
import { useRouter } from '@tanstack/react-router';
import { Button, PageHeader } from '@/components/inputs';
import { usePageTrail } from '../../navigation/usePageTrail';

/**
 * "Page not found", with the shared page header like any other page. The
 * trail is the tenant, then this page: never the matched page's own crumb or
 * icon, since a guard answers "not found" to hide a page (billing for a tenant
 * that isn't charged) and its name would give it away.
 */
export function NotFoundPage() {
  const router = useRouter();
  // The trail's first crumb is the tenant (or Switchboard): keep it, drop the rest.
  const crumbs = [...usePageTrail().slice(0, 1), { label: 'Page not found' }];

  return (
    <div className="space-y-4">
      <PageHeader
        icon={SearchX}
        crumbs={crumbs}
        title="Page not found"
        description="The page you're looking for doesn't exist or has been moved."
        actions={<Button label="Go to Dashboard" preIcon={Home} onClick={() => router.navigate({ to: '/admin' })} />}
      />
    </div>
  );
}
